import axios from "axios";

const API_BASE = "https://api.vyapakprint.com/api"; // change if needed

// check if token exists
export const getToken = () => {
  return localStorage.getItem("adminToken");
};

// logout helper
export const logout = () => {
  localStorage.removeItem("adminToken");
  delete axios.defaults.headers.common.Authorization;
  window.location.href = "/login";
};

// verify token from server
export const verifyAdmin = async () => {
  const token = getToken();
  if (!token) return false;

  try {
    const res = await axios.get(`${API_BASE}/admin/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return res.status === 200;
  } catch {
    logout();
    return false;
  }
};
